export function CompanyDetails() {
  return (
    <section className="py-20 px-6 bg-neutral-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-light text-neutral-900 mb-12 text-center">
          Company Details
        </h2>
        <div className="bg-white p-8 md:p-12 rounded-sm shadow-sm">
          <div className="space-y-6 text-neutral-700">
            <div>
              <h3 className="text-lg font-normal text-neutral-900 mb-2">Company Name</h3>
              <p>AK-KUR Furniture & Fitting Ltd</p>
            </div>
            <div>
              <h3 className="text-lg font-normal text-neutral-900 mb-2">Registered Office Address</h3>
              <p className="leading-relaxed">
                12 Prince Consort Industrial Estate,<br />
                Hebburn, United Kingdom, NE31 1EH
              </p>
            </div>
            <div>
              <h3 className="text-lg font-normal text-neutral-900 mb-2">Company Activity</h3>
              <p>Wholesale of furniture, carpets and lighting equipment (SIC 46470)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
